'use strict';

import ApiEndpoint from './api_endpoint';

export default class Statistics extends ApiEndpoint {
  execute(callback = undefined, session = undefined) {
    if (session === undefined) {
      return this.session.get('/statistics', undefined, callback);
    }
    return session.get('/statistics', undefined, callback);
  };
}
